import * as yup from 'yup';
import { EMAIL_REGEXP, MIN_LENGTH, TAX_ID_REGEXP } from 'utils/constants';
import { VALIDATION_ERROR } from 'utils/enums';
import { IPayerPersonalData, IPaymentPayerFormData } from 'utils/types';

const NAME_FIRST_CHARACTER_REGEXP = /^[-'\u0060\u2019\u2018\u02bc]/;
const NAME_REGEXP = /^[a-zA-Zа-яА-ЯіІїЇєЄґҐ][a-zA-Zа-яА-ЯіІїЇєЄґҐ'\u0060\u2019\u2018\u02bc-]*$/;

export const emailValidationSchema = yup
	.string()
	.required(VALIDATION_ERROR.REQUIRED)
	.matches(EMAIL_REGEXP, { message: VALIDATION_ERROR.EMAIL_INVALID });

export const stringMinLength = yup
	.string()
	.test('first character', VALIDATION_ERROR.FIRST_CHARACTER, (value) => !NAME_FIRST_CHARACTER_REGEXP.test(value as string))
	.matches(NAME_REGEXP, {
		message: VALIDATION_ERROR.SPECIAL_CHARACTERS,
		excludeEmptyString: true,
	})
	.min(MIN_LENGTH, VALIDATION_ERROR.MIN_LENGTH)
	.required(VALIDATION_ERROR.REQUIRED)
	.nullable();

export const taxIdValidationSchema = yup
	.string()
	.required(VALIDATION_ERROR.REQUIRED)
	.matches(TAX_ID_REGEXP, 'ІПН (РНОКПП) має містити рівно 10 цифр');

const payerNameValidationSchema = stringMinLength.nonNullable();

const payerPersonalDataValidationSchema: yup.ObjectSchema<IPayerPersonalData> = yup.object({
	firstName: payerNameValidationSchema,
	lastName: payerNameValidationSchema,
	middleName: payerNameValidationSchema,
	taxId: taxIdValidationSchema,
});

const optionalPayerPersonalDataValidationSchema: yup.ObjectSchema<IPayerPersonalData> = yup.object({
	firstName: yup.string().defined(),
	lastName: yup.string().defined(),
	middleName: yup.string().defined(),
	taxId: yup.string().defined(),
});

export const paymentPayerValidationSchema: yup.ObjectSchema<IPaymentPayerFormData> = yup.object({
	firstName: payerNameValidationSchema,
	lastName: payerNameValidationSchema,
	middleName: payerNameValidationSchema,
	taxId: taxIdValidationSchema,
	isPayerSameAsUltimateDebtor: yup.boolean().required(),
	ultimateDebtor: optionalPayerPersonalDataValidationSchema.when('isPayerSameAsUltimateDebtor', {
		is: false,
		then: () => payerPersonalDataValidationSchema,
		otherwise: () => optionalPayerPersonalDataValidationSchema,
	}),
});

export const userAuthUpdateProfileValidationSchema = yup.object().shape({
	firstName: stringMinLength,
	lastName: stringMinLength,
	middleName: stringMinLength,
});
